import React from "react";

export const GoogleDriveIcon = () => (
  <>
    <svg
      width="35"
      height="32"
      viewBox="0 0 35 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_19993_139549)">
        <mask
          id="mask0_19993_139549"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="35"
          height="32"
        >
          <path
            d="M10.5687 3.94802C13.6491 -1.3159 21.3506 -1.31611 24.4311 3.94802L33.9156 20.1556C36.996 25.4197 33.1454 31.9998 26.9843 31.9998H8.01543C1.85436 31.9998 -1.99628 25.4197 1.08415 20.1556L10.5687 3.94802Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_19993_139549)">
          <path
            d="M-12.6465 32.3261L4.45913 3.0957V3.09622L-0.546237 11.6503H9.46555L21.565 32.3256L-12.6462 32.3259L-12.6465 32.3261Z"
            fill="url(#paint0_linear_19993_139549)"
          />
          <path
            d="M17.8517 -16.5283L29.9509 4.14773L24.9447 12.7024H0.746094L17.8517 -16.5283Z"
            fill="url(#paint1_linear_19993_139549)"
          />
          <path
            d="M45.5526 31.9931H21.3558L16.3486 23.4369L28.447 2.7627L45.5526 31.9931Z"
            fill="url(#paint2_linear_19993_139549)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_19993_139549"
          x1="21.407"
          y1="34.8212"
          x2="-4.43887"
          y2="18.9736"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.15" stopColor="#A9A8FF" />
          <stop offset="0.33" stopColor="#6D97FF" />
          <stop offset="0.48" stopColor="#3186FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19993_139549"
          x1="26.5081"
          y1="-1.46911"
          x2="0.256319"
          y2="10.9507"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.55" stopColor="#0EBC5F" />
          <stop offset="0.85" stopColor="#78C9FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_19993_139549"
          x1="42.0491"
          y1="30.3252"
          x2="18.3869"
          y2="15.9127"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.09" stopColor="#FFE921" />
          <stop offset="1" stopColor="#FEC700" />
        </linearGradient>
        <clipPath id="clip0_19993_139549">
          <rect width="35" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </>
);
